import React, { useEffect } from "react";
import styled from "styled-components";
import { Loader, LoaderSizes, Colors } from "@sellout/ui";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #f9f9f9;
  font-family: sans-serif;
`;

const Text = styled.p`
  margin-top: 20px;
  font-size: 16px;
  color: #333;
  font-weight: 500;
`;

const HiveCallbackPage: React.FC = () => {
    useEffect(() => {
        if (window.opener) {
            const params = new URLSearchParams(window.location.search);
            const code = params.get("code");
            const state = params.get("state");
            const error = params.get("error");
            const error_description = params.get("error_description");

            // Post message back to the parent window (ConnectHiveButton)
            window.opener.postMessage(
                {
                    type: "HIVE_OAUTH_CALLBACK",
                    payload: { code, state, error, error_description }
                },
                window.location.origin
            );

            // Give postMessage a tiny delay before closing the window
            setTimeout(() => {
                window.close();
            }, 100);
        } else {
            // Unlikely fallback if someone goes here directly without a popup
            document.body.innerHTML = "<div style='padding:20px; text-align:center;'>You can safely close this window.</div>";
        }
    }, []);

    return (
        <Container>
            <Loader size={LoaderSizes.Large} color={Colors.Orange} />
            <Text>Authorizing with Hive, please wait...</Text>
        </Container>
    );
};

export default HiveCallbackPage;
